<script>
import Vue from "vue";
import VueTypes from "vue-types";

export default {
  name: "Layout",
  props: {
    name: VueTypes.string.isRequired,
    title: VueTypes.string,
    extraClass: VueTypes.string.def("")
  },
  created() {
    // Check if the layout component
    // has already been registered.
    if (!Vue.options.components[this.name]) {
      Vue.component(this.name, () =>
        import(`@/layouts/${this.name}Layout.vue`)
      );
    }

    this.$parent.$emit("update:layout", this.name);
    this.$parent.$emit("update:layoutTitle", this.title);
    this.$parent.$emit("update:extraClass", this.extraClass);
  },
  render() {
    return this.$slots.default[0];
  }
};
</script>
